import { render, staticRenderFns } from "./MySqlView.vue?vue&type=template&id=63a4dfb5&"
import script from "./MySqlView.vue?vue&type=script&lang=js&"
export * from "./MySqlView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63a4dfb5')) {
      api.createRecord('63a4dfb5', component.options)
    } else {
      api.reload('63a4dfb5', component.options)
    }
    module.hot.accept("./MySqlView.vue?vue&type=template&id=63a4dfb5&", function () {
      api.rerender('63a4dfb5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/shared/mysql/databases/MySqlView.vue"
export default component.exports